<template>
  <div class="myDialog" v-show="visible">
    <div class="dialog__wrapper">
      <div class="dialog wrapper">
        <div class="dialog-content">
          <div class="title">隐私条款更新</div>
          <div class="text">为保障您的知情权，加强对您个人信息安全的保护，我们依据有关法律法规要求和业务需要，重新修订并更新了官网 <a href="/service/policy">《隐私政策》</a>。现向您通知并提示，请您仔细阅读并充分理解相关条款，特别是有关您的权利义务及以争议解决等重要条款。如您拒绝同意我们的隐私条款，您可能无法使用网站部分功能。如果您对我们的隐私政策有任何疑问，可随时按照隐私政策中的方式与我们取得联系。</div>
          <div class="btn">
            <div class="btn1" @click="dialog">同意</div>
            <div class="btn2" @click="toPath">拒绝</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false
    }
  },
  methods: {
    dialogShow() {
      if (!localStorage.getItem('disagree') || localStorage.getItem('disagree') === 'no') {
        this.visible = true
      }
    },
    dialog() {
      localStorage.setItem('disagree', 'yes')
      this.visible = false
    },
    toPath() {
      localStorage.setItem('disagree', 'no')
      this.visible = false
      setTimeout(()=>{
        this.$router.push('/service/disagree').catch(() => {})
      },200)
    }
  },
  watch: {
    $route(to, from) {
      if (to.path === '/service/disagree') {
        this.visible = false
      }
    }
  }
}
</script>

<style scoped>
a {
  color: inherit;
  cursor: pointer;
  text-decoration: none;
  color: #e60012;
}

.dialog__wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding-top: 150px;
  overflow: auto;
  background-color: rgba(0, 0, 0, .5);
  z-index: 99999999999999999;
  transition: .3s;
}

.dialog {
  position: relative;
  width: 50%;
  margin: 0 auto 50px;
  background-color: #fff;
  border-radius: 6px;
  border-top: 3px solid #e60012;
  transition: .3s;
  box-sizing: border-box;
}

.wrapper {
  width: 1280px;
  padding-left: 40px;
  padding-right: 40px;
  margin-left: auto;
  margin-right: auto;
}

.dialog-content {
  padding: 30px;
}

.dialog-content .title {
  padding-bottom: 30px;
  text-align: center;
  font-size: 18px;
}

.dialog-content .text {
  width: 100%;
  height: 300px;
  margin: 25px 0 30px;
  line-height: 25px;
}

.dialog-content .btn {
  width: 100%;
  height: auto;
  text-align: center;
}

.dialog-content .btn .btn1 {
  display: inline-block;
  width: 160px;
  height: auto;
  background: #e70012;
  border-radius: 20px;
  font-size: 14px;
  color: #fff;
  line-height: 40px;
  cursor: pointer;
  vertical-align: middle;
  margin-left: 10px;
}

.dialog-content .btn .btn2 {
  display: inline-block;
  width: 88px;
  height: auto;
  background: #fff;
  border: 1px solid #bdbdbd;
  border-radius: 20px;
  font-size: 14px;
  color: #111212;
  line-height: 40px;
  font-weight: 400;
  cursor: pointer;
  vertical-align: middle;
}

@media (max-width: 1280px) {
  .wrapper {
    width: 960px;
    padding-left: 30px;
    padding-right: 30px;
  }
}

@media (max-width: 960px) {
  .wrapper {
    padding-left: 20px;
    padding-right: 20px;
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Dialog.vue